import { CssBaseline, ThemeProvider } from "@mui/material";

import theme from "./theme";

import { DealsProvider } from "./context/DealsContext";

import { DealProvider } from "./context/DealContext";

import { NotificationsProvider } from "./context/NotificationsContext";

import { DataCompletenessProvider } from "./context/DataCompletenessContext";

import { DataCompletenessDialog } from "./components/dataCompleteness/DataCompletenessDialog";

import { DataCompletenessReminder } from "./components/dataCompleteness/DataCompletenessReminder";

import { GlobalProvider } from "./context/GlobalContext";

import { CurrentUserProvider } from "./context/CurrentUserContext";

import { GlobalReferenceProvider } from "./context/GlobalGetLists";

import { MapsLoaderProvider } from "./context/MapsLoaderContext";

import { AppRoutes } from "./components/AppRoutes";

import { AuthStatus } from "./components/AuthStatus";

import { LoginPage } from "./components/auth/LoginPage";

import { TenantFeaturesProvider, useTenantFeatures } from "./context/TenantFeaturesContext";

import { useAuthContext } from "./context/AuthContext";

import "./assets/css/App.css";



function AuthenticatedApp() {

  const { loading, error } = useTenantFeatures();



  if (loading) {

    return (
      <AuthStatus
        type="loading"
        message="Loading your workspace…"
      />
    );

  }



  if (error) {

    return <AuthStatus type="error" error={error} />;

  }



  return (

    <GlobalReferenceProvider>

      <CurrentUserProvider>

      <GlobalProvider>

        <NotificationsProvider>

        <DataCompletenessProvider>

        <DealsProvider>

          <DealProvider>

            <AppRoutes />

          </DealProvider>

        </DealsProvider>

        <DataCompletenessDialog />

        <DataCompletenessReminder />

        </DataCompletenessProvider>

        </NotificationsProvider>

      </GlobalProvider>

      </CurrentUserProvider>

    </GlobalReferenceProvider>

  );

}



function App() {

  const {

    initializing,

    isAuthenticated,

    showLoginScreen,

    error,

    isRedirecting,

  } = useAuthContext();



  if (error && !showLoginScreen && !isAuthenticated) {

    return (

      <ThemeProvider theme={theme}>

        <CssBaseline />

        <AuthStatus type="error" error={error} />

      </ThemeProvider>

    );

  }



  if (initializing || isRedirecting) {

    return (

      <ThemeProvider theme={theme}>

        <CssBaseline />

        <AuthStatus type={isRedirecting ? "redirecting" : "loading"} />

      </ThemeProvider>

    );

  }



  if (showLoginScreen || !isAuthenticated) {

    return (

      <ThemeProvider theme={theme}>

        <CssBaseline />

        <LoginPage />

      </ThemeProvider>

    );

  }



  return (

    <ThemeProvider theme={theme}>

      <CssBaseline />

      <MapsLoaderProvider>

        <TenantFeaturesProvider>

          <AuthenticatedApp />

        </TenantFeaturesProvider>

      </MapsLoaderProvider>

    </ThemeProvider>

  );

}



export default App;

